import React, { useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import JohnMImage from '../images/johnM.png';
import JohnMSignature from '../images/johnMSignature.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import './Pages.css';

// CEOMessage component
export default function CEOMessage()
{
	localStorage.setItem('activeLinkIndex', '1');

	const navigate = useNavigate();
	const leftArrowRef = useRef(null);
	const rightArrowRef = useRef(null);

	return (
			<>
			<div className='main-container'>
				<Container>
					{/* Content Area */}
					<div className='contentArea flex'>
						{/* Header */}
						<Row className='headerRow'>
							<h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>President and CEO message</h1>
						</Row>
						<hr/>
						<Row>
							<Col lg={6}>
								<p>I am pleased to share our Fiscal Year 2025<sup>*</sup> Corporate Responsibility Report.</p>
								<p>This report details the status and impact of CACI’s environmental, social, and governance (ESG) programs, illustrating the contributions our company makes to the communities, where our people live and work.</p>
								<p>Comprehensive metrics on our employees, culture, and environmental impact show that our persistent efforts to improve sustainability across all company operations while maintaining outstanding performance.</p>
								<p>In addition, you can see how our business imperatives align with and reinforce our culture of informed innovation, steady character, and unwavering integrity that drive our growth and success. For more than six decades, CACI has been steadfast in upholding its ethics-driven principles and enduring commitment to our customers and our nation.</p>
								<p>As CACI works to expand the limits of national security, these core values continue to permeate every aspect of our operations, influencing how we provide capabilities to our customers, as well as our trusted approach to leadership, philanthropy, and environmental stewardship.</p>
								<p>I take great pride in our achievements and our dedication to deliver positive outcomes. That’s what it means to be Ever Vigilant.</p>
								<p>Regards,</p>
								<img alt='John S. Mengucci signature.' src={JohnMSignature} style={{width: '25%'}}/>
								<p style={{fontSize: '1.4rem', fontWeight: '700'}}>John S. Mengucci</p>
								<p>President and Chief Executive Officer <br/>
								CACI International Inc</p>
							</Col>
							<Col lg={6} className='text-end'>
								<img alt='John S. Mengucci, CACI International Inc Presient and Cheif Executive Officer.' className='johnMImage' data-aos='fade-in' data-aos-duration='750' data-aos-delay='300' data-aos-once='true' src={JohnMImage} />
							</Col>
							<Col lg={6}>
							<p style={{fontSize: '0.75rem'}}>*CACI's Fiscal Year 2024 was July 1, 2024 through June 30, 2025.</p>
							</Col>
						</Row>
					</div>
				</Container>
			</div>
			<div className='navigationArrows'>
				<div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
		        onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }}
				onClick={() => {
              navigate('/');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
              	    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
              	    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[0].classList.add('active');
              document.getElementsByClassName('underline')[0].classList.add('active');
            }}>
					<FontAwesomeIcon icon={faArrowLeft} />
				</div>
				<div ref={rightArrowRef} className='arrowContainer rightArrow'
				onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
		        onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/fy2025-highlights');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[2].classList.add('active');
              document.getElementsByClassName('underline')[2].classList.add('active');
            }}>
					<FontAwesomeIcon icon={faArrowRight} />
				</div>
			</div>
			</>
	);
}